import createValidator from '../lib/validator/index'

export default {
  computed: {
    /** NEW VALIDATION WITH VUE VALIDATOR */

    /** STEP 1 */
    /** CHOOSE OFFER VALIDATION */
    offerValidator () {
      return createValidator({
        data: { offer: this.chosenOffer },
        rules: { offer: 'required' }
      }).validate()
    },

    /** STEP 2 */
    /** CGA checked VALIDATION */
    cgaValidator () {
      return createValidator({
        data: { cga: this.cga_checked },
        rules: { cga: 'required|accepted' }
      }).validate()
    },

    /* To know if the current device require a SN or an imei */
    devicesWithSNorImei () {
      return this.devicesWithBrand.map(device => {
        let type
        /* Check if the current device need an imei or a serial number */
        const allowedCategories = this.chosenOffer.allowed_devices_categories
        if (allowedCategories.every(cat => cat.required_device_attribute === 'imei')) {
          type = 'imei'
        } else {
          const chosenCategory = device.chosenCategory
          if (chosenCategory !== null && allowedCategories.filter(cat => cat.name === chosenCategory.name).length > 0) {
            type = allowedCategories.filter(cat => cat.name === chosenCategory.name)[0].required_device_attribute
          }
        }

        device.SNOrImeiNeeded = type === 'imei' ? 'imei' : 'serialNumber'
        return device
      })
    },

    /** STEP 3 */
    /** DEVICE VALIDATION */
    devicesValidator () {
      const purchaseDateValidation = (pass, data, custom) => {
        let purchaseDateRule
        if (custom.max_device_age === 0) {
          purchaseDateRule = 'dateEquals:today'
        } else {
          purchaseDateRule = 'beforeOrEqual:' + custom.date.max + '|afterOrEqual:' + (custom.date[data.category_name]?.min_date || custom.date.min)
        }

        const validator = createValidator({
          data: { purchase_date: data.purchase_date },
          rules: { purchase_date: purchaseDateRule },
          attributes: {
            purchase_date: 'date d\'achat'
          }
        }).validate()
        pass(!validator.fails, validator.errors().list)
      }

      const serialNumberValidation = (pass, data) => {
        if (data.SNOrImeiNeeded === 'serialNumber' && this.chosenOffer.serial_number_required) {
          const validator = createValidator({
            data,
            rules: {
              serialNumber: 'required' + (window.rules.serial_number !== undefined
                ? '|' + window.rules.serial_number
                : '')
            }
          }).validate()
          pass(!validator.fails, [], validator.errors().hasMissing)
        } else pass(true)
      }

      const imeiValidation = (pass, data) => {
        if (data.SNOrImeiNeeded === 'imei' && this.chosenOffer.serial_number_required) {
          const validator = createValidator({
            data,
            rules: { imei: 'required|imei' }
          }).validate()
          pass(!validator.fails, validator.errors().list, validator.errors().hasMissing)
        } else pass(true)
      }

      const brandValidation = (pass, data) => {
        pass(this.data_device.brands.some(brand => brand.id === data.brand_id))
      }

      return createValidator({
        data: this.devicesWithSNorImei,
        rules: {
          'chosenCategory.parent': 'required',
          model: 'required',
          brand: [
            'required', 'requiredWith:brand_id', brandValidation
          ],
          purchase_date: [
            'required', purchaseDateValidation
          ],
          purchase_price: [
            'required',
            'decimal',
            'greaterThan:' + this.chosenOffer?.device_price_min.toFixed(0) || 0,
            'lessThanOrEqual:' + this.chosenOffer?.device_price_max || 0
          ],
          serialNumber: [serialNumberValidation],
          imei: [imeiValidation]
        },
        customData: {
          date: this.date,
          max_device_age: this.chosenOffer.max_device_age
        },
        attributes: {
          'chosenCategory.parent': 'catégorie',
          model: 'modèle',
          brand: 'marque',
          serialNumber: 'numéro de série',
          purchase_date: 'date d\'achat',
          purchase_price: 'prix d\'achat'
        }
      }).validate()
    },

    /** STEP 4 */
    /** CUSTOMER VALIDATION */
    customerValidator () {
      return createValidator({
        data: this.customer_infos,
        rules: {
          gender: 'required',
          last_name: 'required|alphaDash',
          first_name: 'required|alphaDash',
          birthdate: 'required|adult',
          email: 'required|email',
          mobile_phone_number: 'required|phoneNumberInternational',
          phone_number: 'phoneNumberInternational',

          /* company siren for insurances PRO */
          company_siren: 'siren',
          address: 'required',
          postal_code: ['required', this.postalCode],
          country_code: 'required',
          city: 'required'
        },
        customData: {
          availableCountries: window.availableCountries
        },
        attributes: {
          mobile_phone_number: 'téléphone mobile',
          phone_number: 'téléphone fixe',
          country_code: 'pays',
          company_siren: 'SIREN'
        }
      }).validate()
    },

    /** STEP 5 */
    /** PAYMENT VALIDATION */
    paymentValidator () {
      return createValidator({
        data: { iban: this.iban },
        rules: { iban: 'required|iban' }
      }).validate()
    }
  }
}
